import React, { useState } from "react";
import ActionButtons from "../../preapps/ActionButtons";
import StatusBar from "../../preapps/StatusBar";
import PreappChildStatusBar from "./child-status/chils-status";
import moment from "moment";
const PreapChildRowDefault = ({
    t,
    handleClick,
    user,
    status2Percentage,
    showBanks,
    handleCancle,
    handlePdfRun,
    defaultBank,
    activeId,
    show_info,
    handleAppCopy,
    handleChangeOwner,
    currentProgressName,
    isMerchant,
}) => {
    const [showButtons, setShowButtons] = useState(false);
    const handleShowButtons = () => {
        setShowButtons(true);
    };

    const handleHideButtons = () => {
        setShowButtons(false);
    };
    const CurrentProgressionIcon = (progressionId) => {
        if (progressionId < 5) {
            return "#b6d7a8";
        }
        if (progressionId > 4 && progressionId < 10) {
            return "#2b7fdb";
        }
        if (progressionId > 9 && progressionId < 14) {
            return "#e06666";
        }
        if (progressionId > 13 && progressionId < 17) {
            return "#ffa500";
        }
        if (progressionId > 16 && progressionId < 21) {
            return "#60d493";
        }
        if (progressionId > 20 && progressionId < 23) {
            return "#e61a26";
        }
        return "";
    };
    return (
        <div
            className={
                activeId === t[1].id && show_info
                    ? "table-div-tr-inner inner-child-row defalt-row selected"
                    : "table-div-tr-inner defalt-row inner-child-row"
            }
            onMouseLeave={() => {
                handleHideButtons();
            }}
            onMouseEnter={() => {
                handleShowButtons();
            }}
            onClick={(e) => handleClick(t[1].id, t[0])}
        >
            {isMerchant ? (
                <div className="table-div-td col-id  col-id-hover">
                    {t[1].id}
                </div>
            ) : (
                <>
                    {showButtons && (
                        <div className="table-div-td col-id  col-id-hover">
                            {t[1].id}
                        </div>
                    )}
                    {!showButtons && (
                        <div className="table-div-td col-status">
                            {t[1].form_type === 1 ? (
                                user?.channel == "sales_channel" ? (
                                    <StatusBar
                                        sales={true}
                                        currentStatus={currentProgressName(
                                            t[1].lead_progression_id,
                                        )}
                                        statusColor={CurrentProgressionIcon(
                                            t[1].lead_progression_id,
                                        )}
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(t[1])}
                                    />
                                ) : (
                                    <div className="text-right">
                                        Prevet Application
                                    </div>
                                )
                            ) : t[1].progression_id <= 6 ? (
                                user?.channel == "sales_channel" ? (
                                    <StatusBar
                                        sales={true}
                                        currentStatus={currentProgressName(
                                            t[1].lead_progression_id,
                                        )}
                                        statusColor={CurrentProgressionIcon(
                                            t[1].lead_progression_id,
                                        )}
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(t[1])}
                                    />
                                ) : (
                                    <StatusBar
                                        currentStatus={
                                            t[1].progression
                                                ? t[1].progression.status
                                                : ""
                                        }
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(t[1])}
                                    />
                                )
                            ) : (
                                <PreappChildStatusBar t={t[1]} />
                            )}
                        </div>
                    )}
                    <div className="table-div-td col-star star-content">
                        &nbsp;
                    </div>
                    {showButtons && (
                        <div className="table-div-td col-status">
                            {t[1].form_type === 1 ? (
                                user?.channel == "sales_channel" ? (
                                    <StatusBar
                                        sales={true}
                                        currentStatus={currentProgressName(
                                            t[1].lead_progression_id,
                                        )}
                                        statusColor={CurrentProgressionIcon(
                                            t[1].lead_progression_id,
                                        )}
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(t[1])}
                                    />
                                ) : (
                                    <div className="text-right">
                                        Prevet Application
                                    </div>
                                )
                            ) : t[1].progression_id <= 7 ? (
                                user?.channel == "sales_channel" ? (
                                    <StatusBar
                                        sales={true}
                                        currentStatus={currentProgressName(
                                            t[1].lead_progression_id,
                                        )}
                                        statusColor={CurrentProgressionIcon(
                                            t[1].lead_progression_id,
                                        )}
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(t[1])}
                                    />
                                ) : (
                                    <StatusBar
                                        currentStatus={
                                            t[1].progression
                                                ? t[1].progression.status
                                                : ""
                                        }
                                        className="col-status-bar"
                                        style={{ maxWidth: "65px" }}
                                        percentage={status2Percentage(t[1])}
                                    />
                                )
                            ) : (
                                <PreappChildStatusBar t={t[1]} />
                            )}
                        </div>
                    )}
                    {!showButtons && (
                        <div className="table-div-td col-id">{t[1].id}</div>
                    )}
                    {user?.channel == "sales_channel" ? (
                        <div className="table-div-td col-merchant-dba">
                            <span title={t[1].sales_bank_name || <>&mdash;</>}>
                                {t[1].sales_bank_name}
                            </span>
                        </div>
                    ) : (
                        <div className="table-div-td col-merchant-dba">
                            {t[1].bank !== null && (
                                <span title={t[1].bank.name || <>&mdash;</>}>
                                    {t[1].bank.name}
                                </span>
                            )}
                            {t[1].bank == null && (
                                <span title={defaultBank.name || <>&mdash;</>}>
                                    {defaultBank.name || <>&mdash;</>}
                                </span>
                            )}
                        </div>
                    )}
                    <div className="table-div-td col-bank">&nbsp;</div>
                    {user.role !== "agent" && (
                        <div className="table-div-td col-agent">&nbsp;</div>
                    )}
                    <div className="table-div-td col-action-buttons">
                        <ActionButtons
                            user={user}
                            preapp={t[1]}
                            showButtons={showButtons}
                            showAssignBank={false}
                            showMerchantColumn={true}
                            onAssignBank={(preapp) => showBanks(preapp.id)}
                            onCancel={(preapp) => handleCancle(preapp.id)}
                            onReRun={(preapp) => handlePdfRun(preapp.id)}
                            onCopy={(preapp) => handleAppCopy(preapp.id)}
                            onChangeOwnership={() => handleChangeOwner()}
                        />
                    </div>
                    <div className="table-div-td col-approved col-approved-child child">
                        {t[1]?.approved_at != null
                            ? moment(t[1].approved_at).format("MMM D, YYYY")
                            : ""}
                    </div>
                </>
            )}
        </div>
    );
};

export default PreapChildRowDefault;
